import React, { PropsWithChildren } from "react";
import clsx from "clsx";
import Spinner from "../spinner/spinner";
import styles from "./button.module.scss";

interface Props {
  action?(): void;
  link?: string;
  tabIndex?: number;
  disabled?: boolean;
  submit?: boolean;
  loading?: boolean;
  alt?: boolean;
  hideOutline?: boolean;
  block?: boolean;
  simple?: boolean;
  ["data-testid"]?: string;
}
export default function MyNexarButton(props: PropsWithChildren<Props>) {
  const MainElement = (sprops: any) => {
    if (props.link) {
      return (
        <a {...sprops} href={props.link} onClick={props.action}>
          {sprops.children}
        </a>
      );
    } else {
      return (
        <button
          {...sprops}
          onClick={props.action}
          type={props.submit ? "submit" : undefined}
        />
      );
    }
  };

  return (
    <MainElement
      className={clsx(
        styles.ButtonWrapper,
        props.alt && styles.Alt,
        props.block && styles.Block,
        props.hideOutline && styles.HideOutline,
        props.simple && styles.Simple,
      )}
      tabIndex={props.tabIndex}
      disabled={props.loading || props.disabled}
      data-testid={props["data-testid"]}
    >
      {props.loading ? <Spinner /> : props.children}
    </MainElement>
  );
}
